import { Property, SecondContact } from '../../../../../models/Property';
import logo from '../../../../../img/Watco_logo_vertical_Color.svg'
import { checkWatcoContact } from '../../../../../utilities/propertyUtilities';

interface ContactSectionProps {
  property: Property;
}

export default function ContactSection({ property }: ContactSectionProps) {
  const { otherWatcoContact, brokerContact, brokerEmail, watcoContact, watcoContactOther } = property;
  const secondContact: SecondContact | null = otherWatcoContact
    ? { contact: otherWatcoContact, email: 'industrialdevelopment@watco.com', phone: undefined, companyName: null }
    : brokerContact
      ? { contact: brokerContact, email: brokerEmail?.toLowerCase(), phone: property.brokerContactPhone, companyName: property.companyName }
      : null; 

  return (
    <div className="contact-us--container">
      <h4>Contact Information</h4>
      <div className="contact-us--content">
        <div style={{ display: "flex", alignItems: "center" }}>
          <div className="contact-us--contact">
            <div className="contact-us--contact-name">{checkWatcoContact(watcoContact, watcoContactOther)}</div>
            <div className="contact-us--contact-company">Watco</div>
            <a
              href={`mailto:${property?.watcoContactEmail
                ? property.watcoContactEmail
                : 'industrialdevelopment@watco.com'}`}
            >
              {property?.watcoContactEmail ? property?.watcoContactEmail?.toLowerCase() : 'industrialdevelopment@watco.com'}
            </a>
            {property.watcoContactPhone && <div className="contact-us--contact-phone">
              <a href={`tel: ${property.watcoContactPhone}`}>{property.watcoContactPhone}</a>
            </div>}
          </div>
          <img src={logo} alt="Watco Logo" height={64} style={{ margin: "0 auto" }} />
        </div>
        {secondContact &&
          <div className="contact-us--contact">
            <div className="contact-us--contact-name">{secondContact.contact}</div>
            {secondContact.companyName && <div className="contact-us--contact-company">{secondContact.companyName}</div>}
            {secondContact.email && <a href={`mailto:${secondContact.email}`}>{secondContact.email}</a>}
            {secondContact.phone && <div className="contact-us--contact-phone">
              <a href={`tel: ${secondContact.phone}`}>{secondContact.phone}</a>
            </div>}
          </div>
        }
      </div>
    </div>
  );
}